__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/2040f63ed0968e04bf92c3ecf5bfcba5ccdda2595fa394d5a601791f/";